import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Button } from "react-bootstrap";

const TableButton = ({
  onClick,
  enabled
}) => /*#__PURE__*/React.createElement(Button, {
  onClick: () => onClick(),
  variant: "outline-secondary",
  active: enabled,
  title: "Table view"
}, /*#__PURE__*/React.createElement(FontAwesome, {
  name: "fas fa-table"
}));

export default TableButton;